import queryString from "query-string"
import { states } from '../utils/parameters'
const cbAdapter = {
  formatParams(params = {}) {

    const originalParams = { ...params };
    const processedParams = {};
    const skippedParams = {};

    const trackParam = (key, value, processed = true) => {
      if (processed) {
        processedParams[key] = value;
      } else {
        skippedParams[key] = value;
      }
    };

    const locationParams = {};

    if (params.location) {

      if (typeof params.location === 'string') {
        if (/^\d+$/.test(params.location)) {
          locationParams.locationId = params.location;
        } else {
          locationParams.location = params.location;
        }
      } else if (typeof params.location === 'number') {
        locationParams.locationId = String(params.location);
      } else if (typeof params.location === 'object') {
        if (params.location.locationId) {
          locationParams.locationId = String(params.location.locationId);
        } else if (params.location.id) {
          locationParams.locationId = String(params.location.id);
        } else if (params.location.name) {
          locationParams.location = params.location.name;
        }
      }
    }

    if (params.postalCode) {
      locationParams.zipCode = params.postalCode;
    }

    const radius = params.radius || '30'; 
    locationParams.radius = radius;

    if (params.searchRadiusInKilometers) {
      locationParams.searchRadiusInKilometers = params.searchRadiusInKilometers;
    }

    if (params.targetWorkLocation) {

      if (typeof params.targetWorkLocation === 'string') {
        if (/^\d+$/.test(params.targetWorkLocation)) {
          locationParams.targetWorkLocationId = params.targetWorkLocation;
        } else {
          locationParams.targetWorkLocation = params.targetWorkLocation;
        }
      } else if (typeof params.targetWorkLocation === 'number') {
        locationParams.targetWorkLocationId = String(params.targetWorkLocation);
      } else if (typeof params.targetWorkLocation === 'object') {
        if (params.targetWorkLocation.locationId) {
          locationParams.targetWorkLocationId = String(params.targetWorkLocation.locationId);
        } else if (params.targetWorkLocation.id) {
          locationParams.targetWorkLocationId = String(params.targetWorkLocation.id);
        } else if (params.targetWorkLocation.name) {
          locationParams.targetWorkLocation = params.targetWorkLocation.name;
        }
      }
    }



    const alternateLocationParams = {};

    if (params.firstAlternateLocation) {
      if (typeof params.firstAlternateLocation === 'object') {
        const firstAltLoc = params.firstAlternateLocation;
        if (firstAltLoc.city) alternateLocationParams.altCity1 = firstAltLoc.city;
        if (firstAltLoc.state) alternateLocationParams.altState1 = firstAltLoc.state;
        if (firstAltLoc.zipCode) alternateLocationParams.altZipCode1 = firstAltLoc.zipCode;
        if (firstAltLoc.country) alternateLocationParams.altCountry1 = firstAltLoc.country || 'US';
      }
    }

    if (params.secondAlternateLocation) {
      if (typeof params.secondAlternateLocation === 'object') {
        const secondAltLoc = params.secondAlternateLocation;
        if (secondAltLoc.city) alternateLocationParams.altCity2 = secondAltLoc.city;
        if (secondAltLoc.state) alternateLocationParams.altState2 = secondAltLoc.state;
        if (secondAltLoc.zipCode) alternateLocationParams.altZipCode2 = secondAltLoc.zipCode;
        if (secondAltLoc.country) alternateLocationParams.altCountry2 = secondAltLoc.country || 'US';
      }
    }
    if (locationParams.locationId) {
      const locationId = parseInt(locationParams.locationId, 10);
      
     
      const stateMatch = states.find(state => state.locationId === locationId);
      
      if (stateMatch) {
   
        locationParams.stateCode = stateMatch.stateAbbrev;
        locationParams.countryCode = stateMatch.countryAbbrev || "US";
      } else {
     
        let cityFound = false;
        
        for (const state of states) {
          if (state.cities && state.cities.length > 0) {
            const cityMatch = state.cities.find(city => city.locationId === locationId);
            
            if (cityMatch) {
              locationParams.cityName = cityMatch.name;
              locationParams.stateCode = state.stateAbbrev;
              locationParams.countryCode = state.countryAbbrev || "US";
              console.log(`Found city: ${cityMatch.name} in ${state.stateName} (${state.stateAbbrev})`);
              cityFound = true;
              break;
            }
          }
        }
        
        if (!cityFound) {
          console.warn(`Location ID ${locationId} not found in states or cities`);
        }
      }
    }

    let formattedParams = {
      keyword: params.keyword || "",
      pageNumber: params.page || "1",
      rowsPerPage: params.pageSize || "20",
    };

    trackParam('keyword', params.keyword || "");
    trackParam('pageNumber', params.page || "1");
    trackParam('rowsPerPage', params.pageSize || "20");

  
    if (locationParams.location) {
  
      formattedParams.city = locationParams.location?.split(',')?.[0] || "";
      formattedParams.state = locationParams.location?.split(',')?.[1]?.trim() || "";
      trackParam('city', formattedParams.city);
      trackParam('state', formattedParams.state);
    } else if (locationParams.locationId) {

      if (locationParams.stateCode) {
        formattedParams.state = locationParams.stateCode;
        trackParam('state', locationParams.stateCode);
      }
      
      if (locationParams.cityName) {
        formattedParams.city = locationParams.cityName;
        trackParam('city', locationParams.cityName);
      }
      
      if (locationParams.countryCode) {
        formattedParams.country = locationParams.countryCode;
        trackParam('country', locationParams.countryCode);
      }
    }
    if (locationParams.zipCode) {
      formattedParams.zipCode = locationParams.zipCode;
      trackParam('zipCode', locationParams.zipCode);
    }
    if (locationParams.radius) {
      formattedParams.radius = locationParams.radius;
      trackParam('radius', locationParams.radius);
    }
    if (locationParams.searchRadiusInKilometers) {
      formattedParams.radiusInKm = locationParams.searchRadiusInKilometers;
      trackParam('radiusInKm', locationParams.searchRadiusInKilometers);
    }

    if (params.keywordBehavior) {
      let searchPattern;
      switch (params.keywordBehavior.toLowerCase()) {
        case 'and':
          searchPattern = 'And';
          break;
        case 'or':
          searchPattern = 'Or';
          break;
        case 'boolean':
          searchPattern = 'Bool';
          break;
        default:
          searchPattern = params.keywordBehavior; 
      }
      formattedParams.keywordBehavior = searchPattern;
    }

    if (params.jobTitle) formattedParams.jobTitle = params.jobTitle;
    if (params.targetJobTitle) formattedParams.targetJobTitle = params.targetJobTitle;

    if (params.recentCompany) formattedParams.company = params.recentCompany;
    if (params.recentJobDescription) formattedParams.recentJobDescription = params.recentJobDescription;

    if (params.schoolName) formattedParams.school = params.schoolName;

    if (Object.keys(alternateLocationParams).length > 0) {
      formattedParams = { ...formattedParams, ...alternateLocationParams };
    }

    if (params.targetWorkLocationBoolean) formattedParams.targetWorkLocationBoolean = params.targetWorkLocationBoolean;
    if (params.targetWorkSite) formattedParams.targetWorkSite = params.targetWorkSite;

    if (params.CBMinimumExperience) formattedParams.minExperience = params.CBMinimumExperience;
    if (params.CBMaximumExperience) formattedParams.maxExperience = params.CBMaximumExperience;

    if (params.education?.length) formattedParams.education = params.education.join(",");
    if (params.educationMajor) formattedParams.educationMajor = params.educationMajor;
    if (params.minimumDegree) formattedParams.minDegree = params.minimumDegree;

    if (params.careerLevel?.length) formattedParams.careerLevel = params.careerLevel.join(",");
    if (params.workAuthorization?.length) formattedParams.workAuthorization = params.workAuthorization.join(",");

    if (params.securityClearance === true) formattedParams.securityClearance = '1';
    if (params.militaryExperience === true) formattedParams.militaryExperience = '1';

    if (params.employmentType) formattedParams.employmentType = params.employmentType;
    if (params.minimumTravelRequirement) formattedParams.minimumTravelRequirement = params.minimumTravelRequirement;
    if (params.currentlyEmployed === true) formattedParams.currentlyEmployed = '1';
    if (params.managerialExperience === true) formattedParams.managementExperience = '1';
    if (params.projectLeadership === true) formattedParams.projectLeadership = '1';
    if (params.minimumEmployeesManaged) formattedParams.minimumEmployeesManaged = params.minimumEmployeesManaged;
    if (params.maximumCommute) formattedParams.maximumCommute = params.maximumCommute;

    if (params.compensationType) formattedParams.compensationType = params.compensationType;
    if (params.minimumSalary) formattedParams.minimumSalary = params.minimumSalary;
    if (params.maximumSalary) formattedParams.maximumSalary = params.maximumSalary;
    if (params.excludeResumesWithNoSalary === true) formattedParams.excludeResumesWithNoSalary = '1';

    if (params.languagesSpoken?.length) formattedParams.languagesSpoken = params.languagesSpoken.join(",");

  
    if (params.willingToRelocate === true) formattedParams.RelocationFilter = 'RC'; 
    if (params.excludeIVRResumes === true) formattedParams.excludeIVRResumes = '1';

    if (params.workStatus) formattedParams.workStatus = params.workStatus;

    if (params.updatedWithin) formattedParams.freshnessInDays = params.updatedWithin;
    else if (params.freshnessInDays) formattedParams.freshnessInDays = params.freshnessInDays;

    if (params.sortBy) formattedParams.sortBy = params.sortBy;
    if (params.removeDuplicate === true) formattedParams.removeDuplicate = '1';
    if (params.lemmatize === true) formattedParams.lemmatize = '1';

    if (params.nicheInclusion === true) {
      formattedParams.nicheInclusion = '1';
      if (params.nicheInclusionValues && params.nicheInclusionValues.length > 0) {
        formattedParams.nicheInclusionValues = params.nicheInclusionValues.join(',');
      }
    }

    if (params.applyLastActivity === true) formattedParams.applyLastActivity = '1';
    if (params.searchWithMostRecentJobTitle === true) formattedParams.searchWithMostRecentJobTitle = '1';
    if (params.searchWithMostRecentCompany === true) formattedParams.searchWithMostRecentCompany = '1';

    formattedParams.country = params.country || "US";
    trackParam('country', formattedParams.country);


    const formattedQueryString = queryString.stringify(formattedParams);

    return formattedQueryString;
  },

  parseResults: (response) => {
    try {

      if (!response) {
        console.error('Empty response received in parseResults');
        return { results: [], total: 0 };
      }

      if (response.error === true) {
        console.error('Error in response:', response.message);
        return {
          results: [],
          total: 0,
          error: response.message || 'Error fetching candidates'
        };
      }

      const data = response.data || {};

      const candidates = data.results || [];

      if (!candidates.length) {
        return { results: [], total: 0 };
      }

      const results = candidates.map(candidate => {
        try {
          const name = (candidate.ContactName && candidate.ContactName[0]) || 'Unknown';
          const location = candidate.HomeLocation?.[0] || {};
          const city = location.City?.[0] || '';
          const state = location.State?.[0] || '';
          const country = location.Country?.[0] || '';
          const zipCode = location.ZipCode?.[0] || '';

          const formattedLocation = [city, state, country].filter(Boolean).join(', ');

          const resumeId = (candidate.ResumeID && candidate.ResumeID[0]) || '';
          const userId = (candidate.UserDID && candidate.UserDID[0]) || '';

          const currentEmployer = (candidate.RecentEmployer && candidate.RecentEmployer[0]) ||
            (candidate.WorkHistory?.[0]?.ExtCompany?.[0]?.CompanyName?.[0]) || '';

          const currentTitle = (candidate.RecentJobTitle && candidate.RecentJobTitle[0]) ||
            (candidate.WorkHistory?.[0]?.ExtCompany?.[0]?.JobTitle?.[0]) ||
            (candidate.MostRecentTitle && candidate.MostRecentTitle[0]) || '';

          const position = {
            title: currentTitle,
            company: currentEmployer
          };

          const email = (candidate.ContactEmail && candidate.ContactEmail[0]) || '';
          const phone = (candidate.ContactPhone && candidate.ContactPhone[0]) || '';
          const resumeTitle = (candidate.ResumeTitle && candidate.ResumeTitle[0]) || '';

          const getRelevanceScore = () => {
            const rawScore = parseFloat((candidate.RelevanceScore && candidate.RelevanceScore[0]) || 0);
            return Math.min(100, Math.max(0, Math.round(rawScore * 100)));
          };

          const getExperience = () => {
            const expMonths = parseInt((candidate.ExperienceMonths && candidate.ExperienceMonths[0]) || 0);
            const years = Math.floor(expMonths / 12);
            const months = expMonths % 12;
            return { years, months, raw: expMonths };
          };

          const education = (candidate.HighestDegree && candidate.HighestDegree[0]) || '';

          const getDate = () => {
            const timestamp = candidate.TimeStamp?.[0] || candidate.modifiedDate?.[0] || '';
            if (!timestamp) return '';
            try {
              return new Date(timestamp).toISOString();
            } catch (e) {
              return timestamp;
            }
          };

          const isDuplicate = !!candidate.isDuplicate;
          const existingCandidateId = candidate.existingCandidateId || candidate.candidateId || '';

          const notesInfo = candidate.notesInfo || {
            hasNotes: false,
            notesCount: 0,
            notes: []
          };

          const isViewed = !!candidate.isViewed;

          return {
            id: resumeId,
            userId: userId,
            candidateId: existingCandidateId,
            name: name,
            email: email,
            phone: phone,
            location: formattedLocation,
            position: position,
            title: resumeTitle || currentTitle,
            relevanceScore: getRelevanceScore(),
            experience: getExperience(),
            education: education,
            updatedDate: getDate(),
            source: 'CareerBuilder',
     
            isViewed: isViewed,
            isDuplicate: isDuplicate,
            hasResume: true,
        
            notesInfo: notesInfo,
            _original: candidate
          };
        } catch (error) {
          console.error('Error mapping candidate:', error, candidate);
          return null;
        }
      }).filter(Boolean); 
      const pagination = data.pagination || {};
      const totalResults = pagination.totalResults || 0;

      return {
        results,
        total: totalResults,
        filters: {
          skills: data.skills || [],
          industries: data.industries || []
        },
        pagination
      };
    } catch (error) {
      console.error('Error parsing results:', error);
      return {
        results: [],
        total: 0,
        error: error.message
      };
    }
  }
};

export default cbAdapter;

